module.exports = __webpack_public_path__ + "img/fi-rr-eye.f230e08d.svg";